import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import InfoOutlinedIcon from 'housecall-ui/dist/IconsAndImages/Icons/InfoOutlined';
import ActivityFeedEntryPoint from './ActivityFeedEntryPoint.jsx';
import xss from 'xss';
import { isPresent } from 'utils/isPresent';

function ActivityFeedDetails({ classes, item, forToolbar }) {
  let sentEmailsAndOpenInvoices = item.sent_emails_and_open_invoices.map((sentEmailsAndOpenInvoice, index) => {
    return (
      <Typography
        key={index}
        className={classNames(
          classes.lowerCaseText,
          classes.details,
          sentEmailsAndOpenInvoice.has_warning ? classes.redStyle : null
        )}
      >
        {sentEmailsAndOpenInvoice.message}
      </Typography>
    );
  });
  return (
    <Grid container>
      <Grid item xs={12}>
        <ActivityFeedEntryPoint classes={classes} entryPoint={item.entry_point} forToolbar={forToolbar} />
      </Grid>
      {(isPresent(item.data) || isPresent(item.sent_emails_and_open_invoices)) && (
        <React.Fragment>
          <Grid item xs={2} md={1} className={forToolbar ? classes.forToolbarMargin : null}></Grid>
          <Grid item xs={10} md>
            <Typography
              variant="body2"
              dangerouslySetInnerHTML={{ __html: xss(item.data) }}
              className={classes.details}
            />
            {sentEmailsAndOpenInvoices}
          </Grid>
        </React.Fragment>
      )}
    </Grid>
  );
}

ActivityFeedDetails.propTypes = {
  classes: PropTypes.object.isRequired,
  item: PropTypes.object.isRequired,
  forToolbar: PropTypes.bool,
};

ActivityFeedDetails.defaultProps = {
  forToolbar: false,
};

export default ActivityFeedDetails;
